import React from 'react';
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedin,
  FaGithub,
  FaWhatsapp
} from 'react-icons/fa';
import '../App.css';

function Contact() {
  return (
    <div className="text-center">
      <h2 className="section-title">Let's Connect</h2>
      
      <div className="card-custom mx-auto" style={{ maxWidth: '800px', padding: '40px' }}>
        <div className="row g-5 align-items-center">
          <div className="col-md-6 text-start border-end border-secondary border-opacity-25">
            <h5 className="text-accent small text-uppercase fw-bold mb-4 tracking-widest">Contact Details</h5>
            
            <div className="mb-4">
              <p className="text-dim small mb-1">Email</p>
              <a href="mailto:akmsdr2019@gmail.com" className="text-accent text-decoration-none fw-bold fs-5">
                akmsdr2019@gmail.com
              </a>
            </div>

            <div className="mb-4">
              <p className="text-dim small mb-1">Phone</p>
              <a href="tel:+91967400746" className="text-accent text-decoration-none fw-bold fs-5">
                +91 967400746
              </a>
            </div>

            <div>
              <p className="text-dim small mb-1">Location</p>
              <p className="text-main fw-medium">Noida, Uttar Pradesh, India</p>
            </div>
          </div>

          <div className="col-md-6">
            <h5 className="text-accent small text-uppercase fw-bold mb-4 tracking-widest">Social Networks</h5>
            <div className="d-flex justify-content-center gap-4 mb-4">
              <a href="https://github.com/Adarsh09675" target="_blank" rel="noreferrer" className="text-accent fs-3"><FaGithub /></a>
              <a href="https://www.linkedin.com/in/adarsh-mishra-84b397252/" target="_blank" rel="noreferrer" className="text-accent fs-3"><FaLinkedin /></a>
              <a href="https://wa.me/91967400746" target="_blank" rel="noreferrer" className="text-accent fs-3"><FaWhatsapp /></a>
            </div>
            
            <a href="mailto:akmsdr2019@gmail.com" className="btn-glow w-100 d-block text-center py-3">
              Send a Message
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
